import { ObjectUpdate } from '../../../concepts/objects';
import { Rect } from '../../../platform/geom/Rect';
import { CreatePhysicalToolBehavior, CreateTransformableDragParams } from '../../canvas/tooling/CreatePhysicalToolBehavior';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Frame } from '../frame/Frame';
import { Zone } from '../zones/Zone';

// const layoutSpec = [
//     new Rect(0, 0, .5, .5),
//     new Rect(.5, 0, .5, .5),
//     new Rect(0, .5, .5, .5),
//     new Rect(.5, .5, .5, .5),
// ];

const LayoutSpecItem = (title: string, color: string, emoji: string, area: Rect) => ({ title, color, emoji, area });
type LayoutSpecItem = ReturnType<typeof LayoutSpecItem>;
type LayoutSpec = LayoutSpecItem[];

class CreateLayoutToolBehavior extends CreatePhysicalToolBehavior(Frame, 'drag') {

    protected get spec() {
        return this.settings.spec as LayoutSpec;
    }

    protected createSubject(u: ObjectUpdate): Frame {
        const frame = super.createSubject(u);
        frame.title = 'Frame';

        for (const { title, color, emoji } of this.spec) {
            const cell = u.create(Zone);
            cell.title = title;
            cell.autoColor = color;
            cell.emoji = emoji;
            frame.add(cell);
        }

        return frame;
    }

    protected applyDrag(subject: Frame, drag: CreateTransformableDragParams) {
        super.applyDrag(subject, drag);

        const { width, height } = drag.rect(this.grid);

        for (const x of subject.polarize(Zone)) {
            const { area } = this.spec[x.order];

            x.moveTo(width * area.left, height * area.top);
            x.resize(width * area.width, height * area.height);
        }
    }
}

export const layoutTool = defineToolWithCommonBehaviors({
    id: 'layoutTool',
    label: 'Layouts',
    category: 'design',
    weight: 3050,
    behaviors: [CreateLayoutToolBehavior]
});

